import { brandLeanProductTilesRequest } from "@faire/retailer-shared/search/brandLeanProductTilesRequest";
import { LOGGED_OUT_BRAND_PRODUCTS_PAGE_SIZE } from "@faire/retailer-shared/search/consts";
import searchProductsFromBrand from "@faire/web-api/api/v2/search/products/from-brand/post";
import { getQueryKey_escape_hatch as getQueryKeySearchProductsFromBrand } from "@faire/web-api/api/v2/search/products/from-brand/post-hooks";
import { useQuery } from "@tanstack/react-query";

import { useSettingBrandPageRedesign } from "@faire/retailer/settings/useSettingBrandPageRedesign";

import { STALE_TIME } from "../consts";

interface IBrandProfileAndProductInfo {
  brandToken: string;
  selectedCategoryFilterKey: string | undefined;
  refP: string | undefined;
}
export const useBrandLeanProductTilesData = ({
  brandToken,
  selectedCategoryFilterKey,
  refP,
}: IBrandProfileAndProductInfo) => {
  const { isTreatment: isBrandPageRedesign, showCTAVariant } =
    useSettingBrandPageRedesign();
  const brandPageRedesignProductPageSize = showCTAVariant ? 18 : 12;
  const searchProductsFromBrandRequest = brandLeanProductTilesRequest({
    brandToken: brandToken,
    filters: selectedCategoryFilterKey,
    refP: refP,
    pageSize: isBrandPageRedesign
      ? brandPageRedesignProductPageSize
      : LOGGED_OUT_BRAND_PRODUCTS_PAGE_SIZE,
  });

  const {
    data: brandLeanProductTilesData,
    isPending: brandLeanProductTilesIsPending,
    dataUpdatedAt: brandLeanProductTilesDataUpdatedAt,
  } = useQuery({
    queryKey: getQueryKeySearchProductsFromBrand(
      searchProductsFromBrandRequest
    ),
    queryFn: () => searchProductsFromBrand(searchProductsFromBrandRequest),
    staleTime: STALE_TIME,
  });

  return {
    searchProductsFromBrandRequest,
    brandLeanProductTilesData,
    brandLeanProductTilesIsPending,
    brandLeanProductTilesDataUpdatedAt,
  };
};
